import { render, staticRenderFns } from "./RecogidaView.vue?vue&type=template&id=720c93f8&scoped=true"
import script from "./RecogidaView.vue?vue&type=script&lang=js"
export * from "./RecogidaView.vue?vue&type=script&lang=js"
import style0 from "./RecogidaView.vue?vue&type=style&index=0&id=720c93f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720c93f8",
  null
  
)

export default component.exports